import { useLocation } from 'react-router-dom';
import { brand, type Locale } from '../config/brand';

/**
 * Derive the active locale from the URL pathname.
 *
 * Convention: `/en/*` → English, everything else → default (Spanish).
 * This avoids coupling to router params and works consistently across
 * all route nesting levels.
 */
export function useLocale(): Locale {
  const { pathname } = useLocation();
  if (pathname === '/en' || pathname.startsWith('/en/')) return 'en';
  return brand.defaultLocale;
}
